// src/layouts/DashboardLayout.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileNavigation from './MobileNavigation';

const LayoutContainer = styled.div`
  min-height: 100vh;
  background-color: ${props => props.theme.colors.background};
`;

const MainContent = styled.main`
  transition: margin-left 0.3s ease;
  margin-left: 0;
  margin-top: 60px;
  padding: ${props => props.theme.spacing(3)};
  min-height: calc(100vh - 60px);

  @media (min-width: 769px) {
    margin-left: 240px;
  }

  @media (max-width: 768px) {
    padding-bottom: 80px; // Space for mobile navigation
  }
`;

const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <LayoutContainer>
      <Header onMenuToggle={toggleSidebar} />
      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />
      <MainContent>
        {children}
      </MainContent>
      <MobileNavigation />
    </LayoutContainer>
  );
};

export default DashboardLayout;

// // src/layouts/DashboardLayout.js
// import React, { useState } from 'react';
// import styled from 'styled-components';
// import Header from './Header';
// import Sidebar from './Sidebar';
// import Footer from './Footer';
// import { FaBars, FaHome, FaClipboardList, FaTruck, FaCalendarAlt, FaCog } from 'react-icons/fa';

// const LayoutContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   height: 100vh;
// `;

// const ContentWrapper = styled.div`
//   display: flex;
//   flex: 1;
//   overflow: hidden;
//   padding-bottom: 5em;
// `;

// const MainContent = styled.main`
//   flex: 1;
//   padding: 20px;
//   overflow-y: auto;
//   background-color: ${(props) => props.theme.colors.background};
// `;

// const BottomNav = styled.nav`
//   display: none;
//   position: fixed;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   background-color: ${(props) => props.theme.colors.surface};
//   padding: 10px;
//   justify-content: space-around;
//   align-items: center;
//   box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);

//   @media (max-width: 768px) {
//     display: flex;
//   }
// `;

// const NavItem = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   color: ${(props) => props.theme.colors.textPrimary};
//   font-size: 0.8rem;

//   svg {
//     font-size: 1.5rem;
//     margin-bottom: 5px;
//   }
// `;

// const MenuButton = styled.button`
//   display: none;
//   position: fixed;
//   top: 10px;
//   left: 10px;
//   z-index: 1000;
//   background: none;
//   border: none;
//   color: ${(props) => props.theme.colors.textPrimary};
//   font-size: 1.5rem;
//   cursor: pointer;

//   @media (max-width: 768px) {
//     display: block;
//   }
// `;

// const DashboardLayout = ({ children }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   return (
//     <LayoutContainer>
//       <MenuButton onClick={() => setSidebarOpen(!sidebarOpen)}>
//         <FaBars />
//       </MenuButton>
//       <Header />
//       <ContentWrapper>
//         <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
//         <MainContent>{children}</MainContent>
//       </ContentWrapper>
//       <BottomNav>
//         <NavItem>
//           <FaHome />
//           <span>Home</span>
//         </NavItem>
//         <NavItem>
//           <FaClipboardList />
//           <span>Leads</span>
//         </NavItem>
//         <NavItem>
//           <FaTruck />
//           <span>Suppliers</span>
//         </NavItem>
//         <NavItem>
//           <FaCalendarAlt />
//           <span>Jobs</span>
//         </NavItem>
//         <NavItem>
//           <FaCog />
//           <span>Settings</span>
//         </NavItem>
//       </BottomNav>
//     </LayoutContainer>
//   );
// };

// export default DashboardLayout;

// // // src/layouts/DashboardLayout.js
// // import React from 'react';
// // import styled from 'styled-components';
// // import Sidebar from './Sidebar';
// // import Header from './Header';
// // import Footer from './Footer';

// // const LayoutContainer = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   height: 100vh;
// // `;

// // const ContentWrapper = styled.div`
// //   display: flex;
// //   flex: 1;  // Take up all available space
// //   overflow: hidden;
// // `;

// // const MainContent = styled.main`
// //   flex: 1;
// //   padding: 20px;
// //   overflow-y: auto;  // Enable scrolling for the main content
// //   background-color: ${(props) => props.theme.colors.background};
// // `;

// // const DashboardLayout = ({ children }) => {
// //   return (
// //     <LayoutContainer>
// //       <Header />
// //       <ContentWrapper>
// //         <Sidebar />
// //         <MainContent>
// //           {children}
// //         </MainContent>
// //       </ContentWrapper>
// //       <Footer />
// //     </LayoutContainer>
// //   );
// // };

// // export default DashboardLayout;
